module.exports = __webpack_public_path__ + "static/media/faa.b04ceef7.png";